import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const WIB_END = (date) => new Date(`${date}T23:59:59+07:00`).getTime();

const parts = (ms) => ({
  hari: Math.floor(ms / 86400000),
  jam: Math.floor((ms % 86400000) / 3600000),
  menit: Math.floor((ms % 3600000) / 60000),
  detik: Math.floor((ms % 60000) / 1000),
});

export const PromoCountdown = ({ endsAt }) => {
  const [left, setLeft] = useState(() => Math.max(0, WIB_END(endsAt) - Date.now()));

  useEffect(() => {
    const id = setInterval(() => setLeft(Math.max(0, WIB_END(endsAt) - Date.now())), 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  if (left <= 0) return null;
  const p = parts(left);
  const label = new Date(`${endsAt}T00:00:00+07:00`).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Jakarta" });

  return (
    <div className="mx-auto mt-8 inline-flex flex-col items-center gap-3 rounded-2xl border border-[#00D1A8]/30 bg-[#00D1A8]/[0.07] px-6 py-4 backdrop-blur-md" data-testid="promo-countdown">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#00D1A8]">
        <Timer className="h-4 w-4" /> Promo berakhir {label}
      </p>
      <div className="flex gap-2 sm:gap-3">
        {Object.entries(p).map(([k, v]) => (
          <div key={k} className="w-16 rounded-xl border border-white/10 bg-[#040D1D]/80 py-2 text-center sm:w-20" data-testid={`countdown-${k}`}>
            <p className="font-['Manrope',sans-serif] text-2xl font-extrabold tabular-nums text-white sm:text-3xl">{String(v).padStart(2, "0")}</p>
            <p className="text-[10px] uppercase tracking-wider text-slate-400">{k}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
